// Command Center config (clusters, incentive rules, open items) — stored in the
// backend (Mongo) and authenticated with the signed-in admin's Firebase ID token.
// This is Command-Center-only operational config, not shared Brugo domain data.
import api from "@/lib/api";

export const getClusters = () => api.get("/cc/clusters").then((r) => r.data.list || []);
export const putClusters = (list) => api.put("/cc/clusters", { list }).then((r) => r.data.list || []);
export const getIncentives = () => api.get("/cc/incentives").then((r) => r.data.rules || {});
export const putIncentives = (rules) => api.put("/cc/incentives", { rules }).then((r) => r.data.rules || {});

export const getOpenItems = () => api.get("/cc/open-items").then((r) => r.data.items || []);
export const createOpenItem = (b) => api.post("/cc/open-items", b).then((r) => r.data);
export const updateOpenItem = (id, b) => api.patch(`/cc/open-items/${id}`, b).then((r) => r.data);
export const deleteOpenItem = (id) => api.delete(`/cc/open-items/${id}`);

export const getPaymentsLog = () => api.get("/cc/payments-log").then((r) => r.data);
export const getPayMode = () => api.get("/cc/payments/mode").then((r) => r.data);
export const setPayMode = (mode) => api.post("/cc/payments/mode", { mode }).then((r) => r.data);

// Profile (second) password — set/verify, stored server-side with bcrypt.
export const getProfilePwStatus = () => api.get("/cc/profile-password/status").then((r) => r.data);
export const setProfilePw = (password, otpIdToken) => api.post("/cc/profile-password/set", { password, otp_id_token: otpIdToken }).then((r) => r.data);
export const verifyProfilePw = (password) => api.post("/cc/profile-password/verify", { password }).then((r) => r.data);
export const suspendAuth = (uid) => api.post("/cc/accounts/suspend", { uid }).then((r) => r.data);
export const reinstateAuth = (uid, password) => api.post("/cc/accounts/reinstate", { uid, password }).then((r) => r.data);
export const getAuthUsers = () => api.get("/cc/auth-users").then((r) => r.data);
